import styled from 'styled-components';
import { css, breakpoints } from 'src/styles/theme';
import { SummaryPriceDetailsStyled } from '../SummaryPriceDetailsStyled';
import { rem } from 'polished';

export const SummaryPriceDetailsAC = styled(SummaryPriceDetailsStyled)`
    border-top: ${rem(1)} solid ${({ theme }) => theme.colors.grey16};

    ${({ isBasket }) =>
        !isBasket &&
        css`
            border-bottom: ${rem(1)} solid ${({ theme }) => theme.colors.grey2};
        `}

    ${({ isBasket, isDealer }) =>
        !isBasket &&
        !isDealer &&
        css`
            border-top: unset;
            border-bottom: unset;
            @media (min-width: ${breakpoints.sm}px) {
                border-top: ${rem(1)} solid ${({ theme }) => theme.colors.grey2};
                border-bottom: ${rem(1)} solid ${({ theme }) => theme.colors.grey2};
            }
        `}

    .descriptionWrapper > .description > .info > .key {
        color: ${({ theme }) => theme.colors.grey13};
    }

    .descriptionWrapper {
        .info {
            .value {
                color: ${({ theme }) => theme.colors.grey5};
            }
        }
    }

    .descriptionTitle {
        font-size: ${({ theme }) => theme.fontSizes.h4};
        color: ${({ theme }) => theme.colors.grey5};
    }

    .totalPriceWrapper {
        color: ${({ theme }) => theme.colors.grey5};

        .totalPriceTitle {
            font-size: ${({ theme }) => theme.fontSizes.h4};
        }
        .totalPrice {
            .cashPrice {
                font-size: ${({ theme }) => theme.fontSizes.h3};
            }
        }

        .isShowPriceExcludedVAT-container {
            .cashPrice,
            & > .isShowPriceExcludedVAT {
                .formatMoney {
                    font-size: ${rem('20px')};
                }
            }
        }

        .monthlyPrice {
            margin-top: ${rem('5px')};
            .formatMoney {
                font-size: ${({ theme }) => theme.fontSizes.h3};
            }
            .icon-wrapper {
                svg {
                    margin: unset;
                    height: ${rem('16px')};
                    width: ${rem('16px')};
                    circle {
                        fill: ${({ theme }) => theme.colors.grey2};
                        stroke: none;
                    }

                    line {
                        stroke: ${({ theme }) => theme.colors.white};
                        stroke-width: ${rem('3px')};
                    }
                }
            }
        }
        .priceInfo {
            .promotionalText {
                font-size: ${({ theme }) => theme.fontSizes.h6};
            }
        }
    }

    .titleWrapper {
        .title {
            font-size: ${({ theme }) => theme.fontSizes.h2};
            color: ${({ theme }) => theme.colors.grey5};
        }
        .isClose {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.red};
                }
            }
        }
        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.red};
                }
            }
        }
    }

    .descriptionSection {
        color: ${({ theme }) => theme.colors.grey5};
    }

    .configuration {
        button {
            &:hover,
            &:focus-visible {
                color: ${({ theme }) => theme.colors.grey5};

                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.grey5} !important;
                    }
                }
            }
        }
    }

    .finance {
        .financePersonalize {
            .financeWidgetLink,
            .financeDetailLinkDesktop {
                &:hover,
                &:focus-visible {
                    color: ${({ theme }) => theme.colors.red};
                    border-color: ${({ theme }) => theme.colors.red};
                }
            }
        }
    }

    .infoIcon {
        display: inline-block;
        .vertical {
            margin: 0;
            height: ${rem(16)};
        }

        svg {
            g {
                circle {
                    fill: ${({ theme }) => theme.colors.grey2};
                    stroke: ${({ theme }) => theme.colors.grey2};
                }
                line {
                    stroke: ${({ theme }) => theme.colors.white};
                }
            }
        }
    }
`;
